import { mapState, mapActions } from 'vuex';

import { useDataLoading } from '@mixins/factories';

import { APP_SETTINGS_NAMESPACE, AppSettingsActionTypes } from '@store';

const dataLoadingOptions = {
  getterName: 'getDigitalSettings', searchable: false, paged: false, parameterize: true,
};

export default {
  name: 'DigitalSettings',

  mixins: [
    useDataLoading(dataLoadingOptions),
  ],

  data() {
    return {
      // digitalSettings: {},
      digitalSettingsCode: '',
    };
  },

  computed: {
    ...mapState('digitalSettings', {
      settingsCodeStr: ({ settings }) => JSON.stringify(settings || {}, null, '\t'),
    }),

    ...mapState('operators', {
      operatorsConfig: ({ allOperators }) => allOperators.map(({ id: value, name: text }) => ({
        value, text,
      })),
    }),
  },

  watch: {
    settingsCodeStr: {
      handler(newValue) {
        this.digitalSettingsCode = newValue;
      },
      immediate: true,
    },

    // settings: {
    //   handler(newValue) {
    //     Object.assign(this, {
    //       digitalSettings: {
    //         ...newValue,
    //       },
    //     });
    //   },
    //   immediate: true,
    // },
  },

  created() {
    this.getAllOperators();
  },

  methods: {
    ...mapActions('digitalSettings', ['getDigitalSettings', 'setDigitalSettings']),

    ...mapActions('operators', ['getAllOperators']),

    ...mapActions(APP_SETTINGS_NAMESPACE, {
      getAppDigitalSettings: AppSettingsActionTypes.GET_APP_DIGITAL_SETTINGS,
    }),

    updateSettings() {
      this.$VBlackerTheme.alert.warning({
        text: 'Update settings?',
      }, async () => {
        this.$VBlackerTheme.openLoadingSpinner();

        try {
          // await this.setDigitalSettings({ settings: this.digitalSettings });
          await this.setDigitalSettings({ settings: JSON.parse(this.digitalSettingsCode) });

          this.getAppDigitalSettings();

          this.$VBlackerTheme.notification.success('Digital settings successfully updated');
        } catch (e) {
          this.$VBlackerTheme.notification.error(e);
        } finally {
          this.$VBlackerTheme.closeLoadingSpinner();
        }
      });
    },
  },
};
